<template>

  <v-layout>
    <v-flex xs12>

      <v-card>
        <v-card-title>
          <span class="headline">Cupons Adquiridos</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout
              row
              wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="search"
                  label="Pesquisar"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                />
              </v-flex>
            </v-layout>
          </v-container>
          <template v-if="items.length > 0">
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :items-per-page="10"
              :loading="loading"
              class="elevation-1"
            >
              <template
                slot="items"
                slot-scope="props">
                <td><b style="color: blue">{{ props.item.codigo }}</b></td>
                <td>{{ props.item.status }}</td>
                <td>{{ props.item.data_maximo }}</td>
                <td>
                  <v-btn
                    v-if="props.item.status_id === 1 && !props.item.vencido"
                    color="primary"
                    dark
                    @click="copiar(props.item.codigo)"
                  >
                    <v-icon>mdi-share</v-icon>
                  </v-btn>
                </td>
              </template>

            </v-data-table>
          </template>
        </v-card-text>

      </v-card>
    </v-flex>
  </v-layout>

</template>
<script>
import {
  mapGetters,
  mapActions
  ,
  mapState
} from 'vuex'
import moment from 'moment'
export default {
  data () {
    return {
      headers: [{
        text: 'Cupom',
        align: 'left',
        sortable: false,
        value: 'codigo'
      },
      {
        text: 'Status',
        align: 'left',
        sortable: false,
        value: 'status'
      },
      {
        text: 'Data de Validade',
        align: 'left',
        sortable: false,
        value: 'data_maximo'
      }
      ],
      items: [],
      search: '',
      loading: false
    }
  },
  computed: {
    ...mapState('app', ['cupons', 'step', 'user', 'trava_back', 'curr_version', 'strings', 'idioma'])
  },
  watch: {
    cupons: function () {
      this.items = []
      this.cupons.forEach(cupom => {
        this.items.push({
          codigo: cupom.codigo,
          status: cupom.status === 1 ? 'Disponivel para uso!' : cupom.status === 2 ? 'Já Utilizado!' : cupom.status === 0 ? 'Inativo' : cupom.status === -1 ? 'Aguardando Pagamento!' : 'Expirado',
          data_maximo: moment(cupom.data_maximo).format(this.strings[this.idioma].formato_datas_sem_hora),
          vencido: moment(cupom.data_maximo).isBefore(moment()),
          status_id: cupom.status
        })
      })
      console.log(this.items)
    }
  },
  created () {
    this.getCupons()
  },
  methods: {
    ...mapActions(['getCupons']),
    copiar (codigo) {
      this.$copyText(codigo).then(() => {
        alert('Copiado com sucesso!')
      })
    }

  }
}
</script>
